import { Card, CardHeader, Box, Collapse, Stack, IconButton, Typography } from '@mui/material';
import { useState } from 'react';
import palette from 'theme/palette';
import { TNote } from '../types';
import Icon from '@/units/Icon';
import { DateGroupByType, ListGroupByType, NoteStatus } from '../enums';

type Props = {
  rtl: boolean;
  groupKey: string | number;
  groupName: string;
  notes: TNote[];
  // userId: number;
  // onThreadItemSelect: (note: TThread) => void;
  // newThreadMessages: { [key: number]: number };
  // editMode: boolean;
  // showCaseTemp: any;
  // tagNode: any;
  // inputNodeComponent: any;
  // controls: any;
  // showcaseTag: any;
  // tourSlug: string;
  // setEditMode: (value: boolean) => void;
  groupBy: ListGroupByType | DateGroupByType;
  children: React.ReactNode;
};

export const NotesGroup = ({ groupName, notes, rtl, groupBy, groupKey, children }: Props) => {
  // const { collaborators } = useNotesContext();

  const [open, setOpen] = useState(true);
  const renderGroupIcon = () => {
    if (groupBy === ListGroupByType.Tags) {
      return <Icon.CircleTag />;
    }

    if (groupBy === ListGroupByType.Status) {
      if (groupKey === NoteStatus.Completed) {
        return <i className="fa fa-check" style={{ color: '#12B76A', fontSize: '18px' }} />;
      }

      return (
        <i
          className="fa-regular fa-arrow-rotate-left"
          style={{ color: '#FB6514', fontSize: '18px' }}
        />
      );
    }

    return null;
  };

  return (
    <Card
      sx={{
        border: '1px solid #D0D5DD',
        borderRadius: '16px',
        background: 'white',
        backdropFilter: 'none',
        padding: '16px',
      }}
      key={groupName}
    >
      <CardHeader
        title={
          <Stack direction="row" sx={{ alignItems: 'center' }} gap="6px">
            {renderGroupIcon()}
            <Typography
              sx={{
                fontWeight: '700',
                fontSize: '16px',
                color: '#101828',
                display: '-webkit-box',
                WebkitBoxOrient: 'vertical',
                WebkitLineClamp: 1,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {groupName}
            </Typography>
            <Box
              component="div"
              sx={{
                backgroundColor: '#F2F4F7',
                borderRadius: '50%',
                display: 'inline-flex',
                width: '24px',
                height: '24px',
                textAlign: 'center',
                padding: '4px',
                justifyContent: 'center',
                alignItems: 'center',
                flexShrink: 0,
              }}
            >
              <Box
                component="span"
                sx={{
                  fontSize: '14px',
                  color: '#2055FF',
                }}
              >
                {notes.length ?? 0}
              </Box>
            </Box>
          </Stack>
        }
        sx={{ textAlign: rtl ? 'right' : 'left', direction: rtl ? 'rtl' : '', padding: 0 }}
        action={
          <IconButton
            onClick={() => setOpen(!open)}
            aria-label="expand"
            size="small"
            sx={{ marginRight: 2, marginTop: '5px' }}
          >
            <Icon.ChevronDown
              sx={{
                transform: open ? 'rotate(0deg)' : 'rotate(180deg)',
                transition: 'transform 0.3s ease-in-out, color 0.15s',
                '&:hover ': {
                  color: palette.light.primary.main,
                },
                '&:active ': {
                  color: palette.light.primary.dark,
                },
              }}
            />
          </IconButton>
        }
      />

      <Collapse in={open} timeout="auto" unmountOnExit>
        <Stack gap="14px" mt="14px">
          {children}
          {/* {notes.map((note: TThread) => {
          return (
            <NoteCard
              setEditMode={setEditMode}
              controls={controls}
              inputNodeComponent={inputNodeComponent}
              tagNode={tagNode}
              showCaseTemp={showCaseTemp}
              showcaseTag={showcaseTag}
              tourSlug={tourSlug}
              editMode={editMode}
              newMessagesCount={newThreadMessages[note.id] || 0}
              rtl={rtl}
              note={note}
              collaborators={collaborators}
              userId={userId}
            />
          );
        })} */}
        </Stack>
      </Collapse>
    </Card>
  );
};
